module.exports = __webpack_public_path__ + "02_short_black.cf902c2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/02_short_black.png
// module id = B99E
// module chunks = 0